import React from "react";

export default ({ data }) => {
  return <td className="table-cell">{data?.text}</td>;
};
